import { ModalComponent, ToastMessage } from "components";
import React, { useState } from "react";
import EditLocationCategory from "./EditLocationCategory";
import styled from "styled-components";

const CategoryId = styled.span`
    color: rgba(0, 107, 180, 1);
    font-size: 20px;
    font-weight: 700;
    margin-left: 22px;
`;
const CategoryHeader = styled.span`
    width: 100%;
    font-size: 1.6rem;
    font-weight: 700;
    color: #111827;
`;
function EditLocationCategoryModal({
    showLocationCategoriesEditModal,
    setShowLocationCategoriesEditModal,
    handleCloseLocationCategoriesEditModal,
    selectedLocationCategoryData,
}) {
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [locationName, setLocationName] = useState(null);
    // eslint-disable-next-line no-shadow
    const onSuccess = (locationName) => {
        setShowLocationCategoriesEditModal(false);
        setLocationName(locationName);
        setShowSuccessMessage(true);
    };
    return (
        <>
            <ModalComponent
                header={
                    <CategoryHeader>
                        Edit Location Category
                        <CategoryId>{selectedLocationCategoryData?.id} #</CategoryId>
                    </CategoryHeader>
                }
                open={showLocationCategoriesEditModal}
                size="large"
                borderedHeader
                onClose={handleCloseLocationCategoriesEditModal}
            >
                <EditLocationCategory
                    onClose={handleCloseLocationCategoriesEditModal}
                    selectedLocationCategoryData={selectedLocationCategoryData}
                    onSuccess={onSuccess}
                />
            </ModalComponent>
            {showSuccessMessage && (
                <ToastMessage
                    type="success"
                    showToast={showSuccessMessage}
                    setShowToast={setShowSuccessMessage}
                    name={locationName}
                    text="info edits have been submitted successfully."
                />
            )}
        </>
    );
}

export default EditLocationCategoryModal;
